// src/app/componentes/AdminProtectedRoute.tsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAdminAuth } from "hooks/useAdminAuth";
import { AdminRole } from "services/admin/adminAuth.types";

type Props = {
  requiredRoles?: AdminRole[];
};

export default function AdminProtectedRoute({ requiredRoles }: Props) {
  const { isAuthenticated, loading, admin } = useAdminAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  if (requiredRoles?.length && admin && !requiredRoles.includes(admin.role)) {
    return <Navigate to="/admin" replace />;
  }

  return <Outlet />;
}
